export const jobStatus = [
  "Employed",
  "Self Employed",
  "Part Time",
  "Career Break",
] as const;
